import B2BProposalForm from './_b2b-v2'
import '../scss/parts/_b2b-v2.scss'

const initB2B = () => {
	document.querySelectorAll('.b2b-v2').forEach(root => {
		new B2BProposalForm(root).init()
	})
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initB2B, { once: true })
} else {
	initB2B()
}
